import { Injectable } from '@angular/core';
//import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { NavMenu } from './nav-menu.interface';

@Injectable({
  providedIn: 'root',
})
export class NavMenuService {
  //constructor(private http: HttpClient) {}

  getUserName(): Observable<NavMenu> {
    //return this.http.get<NavMenu>(`/api/navmenu`);
    return new Observable<NavMenu>((observer) => {
      observer.next({ userName: 'brugernavn' });
      observer.complete();
    },);
  }
}
